export const libraries = ['places']

export const MEETING_POINT_STATUS = {
  SINGLE_EDIT: 'SINGLE_EDIT',
  SINGLE_ADD: 'SINGLE_ADD',
  MULTIPLE_SET: 'MULTIPLE_SET',
  MULTIPLE_ADD: 'MULTIPLE_ADD',
  MULTIPLE_EDIT: 'MULTIPLE_EDIT',
}
